import React, { Suspense, useState } from 'react'
import { StyleSheet, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { Spacing } from 'zens-storybook'
import { Draft, UserData, useStore, useUserMutation } from 'zens-store'
import { useRouter, useNumberParams } from 'zens-router'
import { LayoutHeader, UserDetail, UserHeader, UserRevokeConfirm } from '@dms/component'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    margin: Spacing.L,
  },
})

const UserDetailScreen = () => {
  const [confirmDelete, setConfirmDelete] = useState<Draft<UserData>>()
  const [{ userId, companyId }] = useNumberParams()
  const router = useRouter()
  const { message, auth } = useStore()
  const { t } = useTranslation()
  const mutation = useUserMutation({ companyId })
  const revokeUser = async (draft: Draft<UserData>) => {
    try {
      await mutation.revoke(draft)
      message.add({
        message: t('User is succesfully removed from this company'),
        status: 'success',
      })
      if (draft.data.id === auth.profile?.id) {
        router.push(`/companies`)
      } else {
        router.push(`/companies/${companyId}/users`)
      }
    } catch (error) {
      const { message: errorMessage } = error as Error
      console.debug(`USER: User revoke failed: ${errorMessage}`)
      message.add({
        message: `${t('User could not be removed from this company')}. ${errorMessage}`,
        status: 'error',
      })
    }
  }

  return (
    <View style={styles.container}>
      <Suspense fallback={<LayoutHeader.Skeleton breadcrumb title />}>
        <UserHeader companyId={companyId} userId={userId} />
      </Suspense>
      <Suspense fallback={<UserDetail.Skeleton style={styles.content} />}>
        <UserDetail companyId={companyId} userId={userId} onRevoke={setConfirmDelete} style={styles.content} />
      </Suspense>
      <UserRevokeConfirm
        visible={!!confirmDelete}
        onClose={() => setConfirmDelete(undefined)}
        onRevoke={() => revokeUser(confirmDelete!)}
      />
    </View>
  )
}

export default UserDetailScreen
